import * as React from 'react'

export interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
  return (
    <label className="relative inline-flex cursor-pointer items-center">
      <input ref={ref} type="checkbox" className="peer sr-only" {...props} />
      <div className="h-5 w-9 rounded-full bg-muted transition-colors peer-checked:bg-primary" />
      <div className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-foreground transition-transform peer-checked:translate-x-4" />
    </label>
  )
})
Switch.displayName = 'Switch'

